import Component from "../../lib/component";
import {getThrottledFunction} from "../../helpers/throttle";

export const ProfileBannerSpaceConfig = {
    componentTypeKey: 'ProfileBannerSpace',
    baseHtmlClass: 'profile_banner__space',
    selector: '.profile_banner__space',

    datasetConfigKey: 'profile_banner__space__config',

    landscapeOrientation: 'landscape',
    portraitOrientation: 'portrait',
};

export class ProfileBannerSpace extends Component {

    static get config() {
        return ProfileBannerSpaceConfig;
    }

    constructor(id_or_element, profileBanner) {
        super({
            element: id_or_element,
            config: ProfileBannerSpace.config
        });

        this.profileBanner = profileBanner;

        this.insets = getInsetsConfig(profileBanner);

        this.orientation = getWindowOrientation();

        const resizeHandler = getThrottledFunction(this.handleResize.bind(this), 10);
        this.observer = new ResizeObserver(resizeHandler);
        this.observer.observe(document.body);
    }

    handleResize() {
        const newOrientation = getWindowOrientation();
        if (newOrientation === this.orientation) return;
        this.orientation = newOrientation;
        this.profileBanner.render();
    }

    render() {
        const inset = this.getInsetCSS();
        if (inset) this.element.style.inset = inset;
    }

    getInsetCSS() {
        const orientation = getWindowOrientation();

        const top = this.insets[orientation]['top'] ?? "0%";
        const right = this.insets[orientation]['right'] ?? "0%";
        const bottom = this.insets[orientation]['bottom'] ?? "0%";
        const left = this.insets[orientation]['left'] ?? "0%";
        const insets = `${top} ${right} ${bottom} ${left}`;
        return insets;
    }

}


function getInsetsConfig(profileBanner) {
    return profileBanner.getDatasetConfigValue('insets');
}

export function getWindowOrientation() {
    return window.innerWidth > window.innerHeight ? ProfileBannerSpace.config.landscapeOrientation : ProfileBannerSpace.config.portraitOrientation;
}
